﻿import {BillSummaryGateway} from './billSummary.gateway';
import {BillSummaryViewModel} from './billSummary.viewmodel';
import * as Models from "../../models/models";
import * as LogService from "../../core/services/logservice/log.service";
import * as HttpDataServiceBase from "../../core/httpdataservicebase";
import * as Repositories from "../../repositories/repositories";
import {ScreenLockService} from "../../core/services/screenLockService/screenLock.service";
import {IErrorRedirectService} from '../../core/services/errorRedirectService/errorRedirect.service';
import {ErrorInformation} from '../../core/services/errorRedirectService/errorInformation.model';

export class BillSummaryController {

    private parameters: Models.IBillingStatementPageParams;
    private billSummaryViewModel: BillSummaryViewModel;
    private billSummaryForm: ng.IFormController;

    static $inject = ['errorRedirectService','ValidationService', '$state', '$uibModal', '$scope', '$stateParams', 'logService', 'screenLockService', 'billSummary.gateway', '$q'];

    constructor(private errorRedirectService: IErrorRedirectService,
        private validationService: any,
        private $state: ng.ui.IStateService,
        private $modal: any,
        private $Scope: any,
        private $stateParams: Models.IBillingStatementPageParams,
        private logger: LogService.ILogService,
        private screenLockService: ScreenLockService,
        private billSummaryGateway: BillSummaryGateway,
        private $q: ng.IQService) {

        this.activate();

    }

    private activate() {

        // this is required in order to set up the validation service to work with the form using "controller as" syntax
        this.validationService = new this.validationService({ controllerAs: this });

        this.screenLockService.broadcast(1);

        this.billSummaryViewModel = new BillSummaryViewModel();
        this.screenLockService.broadcast(1);
        this.billSummaryGateway.loadBillSummaryViewModel(this.billSummaryViewModel)
            .then(() => {
                this.screenLockService.broadcast(0);

            });
    }

    public goHome(): void {
        this.$state.go('shellFrame.accountFrame.accountSummary');
    }


}
